export const META_PIXEL_ID = '1012782631449952'

let initialized = false

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    ;(
      b.head ||
      b.getElementsByTagName('head')[0] ||
      b.documentElement
    ).appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}
